export const CULTURE_ACTIONS = {
  FETCH_CULTURES: 'CULTURES/FETCH_CULTURES',
  FETCH_CULTURES_SUCCESS: 'CULTURES/FETCH_CULTURES_SUCCESS',
  FETCH_CULTURES_ERROR: 'CULTURES/FETCH_CULTURES_ERROR',
};
